import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const DATE = 'date'
const ACTIVITIES = 'activities'
const LOG = 'log'
const MARK = 'mark'

const today = new Date()
today.setHours(0, 0, 0, 0)

/**
 * Form model
 */
const formModel = () => {
  return {
    [DATE]: {
      label: `Date`,
      name: DATE,
      required: true,
    },
    [ACTIVITIES]: {
      label: `Activities`,
      name: ACTIVITIES,
    },
    [LOG]: {
      label: `Special teacher log`,
      name: LOG,
    },
    [MARK]: {
      label: `Mark`,
      name: MARK,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [DATE]: null,
  [ACTIVITIES]: '',
  [LOG]: '',
  [MARK]: '',
}


export default formModel
